import { CheckJunkData } from './development/CheckJunkData';
import { DataService } from '../../services/data_service';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { ToolExportImport } from './development/ToolExportImport';
import { WForm, WFormConfig, WFormData } from '../../core/forms/WFormFramework';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

interface DevelopmentPreviewProps extends React.ClassAttributes<any> {
    data: any;
}

export interface DevelopmentPreviewState {
    data: any;
    formConfig: WFormConfig
}

export class DevelopmentPreview extends React.Component<DevelopmentPreviewProps, DevelopmentPreviewState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: {},
            formConfig: null
        };
    }

    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.loadData();
    }

    loadData(): void {
        this.dataService.loadData('devel_wketool_94', null, null, (res: any) => {
            let data = this.state.data;
            data = { ...data, ...res };
            this.setState({ data });
        }, IDs.MOD_ETOOL_ADMIN);

        this.dataService.loadData(IDs.ENT_ENERGIEDATEN_WAERME_EINHEITEN, null, null, (res: any) => {
            let data = this.state.data;
            data = { ...data, ...res };
            this.setState({ data });
        }, IDs.MOD_ETOOL);

        const struct_tool = new StructureTool(IDs.MOD_ETOOL_ADMIN);
        struct_tool.generateFormConfig('devel_wketool_94', (formConfig: WFormConfig) => this.setState({ formConfig }));
    }

    render(): JSX.Element {
        return <Tabs
            className='tabs-admin-main'
            style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
        >
            <TabList style={{ minHeight: 20 }}>
                <Tab>Tools Export / Import</Tab>
                <Tab>Junk-Daten suchen</Tab>
                <Tab>Test Formular 1</Tab>
                <Tab>Test Formular 2</Tab>
            </TabList>
            <TabPanel>
                {this.renderWKETOOL107()}
            </TabPanel>
            <TabPanel>
                {this.renderCheckJunkData()}
            </TabPanel>
            <TabPanel>
                {this.renderWKETOOL94()}
            </TabPanel>
            <TabPanel>
                {this.renderWKETOOL94KForm()}
            </TabPanel>
        </Tabs>;
    }

    renderWKETOOL107(): JSX.Element {
        return <ToolExportImport />;
    }

    renderCheckJunkData(): JSX.Element {
        return <CheckJunkData />;
    }

    renderWKETOOL94(): JSX.Element {
        return <>
            <WFormsTableWrapper
                entity={'devel_wketool_94'}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
            />
        </>;
    }

    renderWKETOOL94KForm(): JSX.Element {
        const { data, formConfig } = this.state;
        console.log(data, formConfig);
        const dataRows = data && Array.isArray(data['devel_wketool_94']) ? data['devel_wketool_94'] : [];
        const formValues = dataRows.length > 0 ? dataRows[0] : null;
        if (!formValues || !formConfig) {
            return null;
        }
        return <>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <WForm
                    entity={'devel_wketool_94'}
                    bundle={data}
                    module={IDs.MOD_ETOOL_ADMIN}
                    titel={'Formular'}
                    layout={'sidebysideComplex'}
                    config={formConfig}
                    dataIn={this.getFormData(formValues)}
                    onFormSave={(formItem: WFormData) => {

                    }}
                    onFormCancel={() => { }}
                    customCssStyle={{
                        formcontainer: {
                            height: 'unset',
                            minHeight: 'unset'
                        }
                    }}
                    hideCancel={true}
                    hideSave={true}
                    hideTitel={true}
                />
            </div>
        </>;
    }

    getFormData(formValues: any) {
        const formData = new WFormData();
        if (formValues) {
            const itemCopy = { ...formValues };
            Object.keys(formValues).forEach((key: string) => {
                if (key.slice(-5) === '_orig') {
                    itemCopy[key.slice(0, -5) + '_name'] = itemCopy[key.slice(0, -5)];
                    itemCopy[key.slice(0, -5)] = formValues[key];
                }
            });
            formData.overwriteAllValues(itemCopy);
        }
        return formData;
    }
}
